import {
  Filter,
  FilterMatchingType,
} from "interfaces/filters";
import { TagType } from "interfaces/tags";

export const filtersDefs: Array<Filter> = [
  {
    name: 'name',
    path: [],
    label: 'Product Name',
    matching: FilterMatchingType.ARRAY_INCLUDES_PROPERTY_DROPDOWN,
    key: 'name',
    value: [],
    options: 'products',
  },
  {
    name: 'revenueType',
    path: [],
    label: 'Revenue Type',
    matching: FilterMatchingType.ARRAY_INCLUDES_PROPERTY,
    key: 'revenueType',
    value: [],
    options: 'revenueTypeOptions',
  },
  {
    name: 'tags',
    path: ['tags'],
    label: 'Tags',
    matching: FilterMatchingType.ARRAY_INCLUDES_PROPERTY_DROPDOWN,
    key: 'name',
    isArray: true,
    value: [],
    options: 'tags',
    tagType: TagType.PRODUCT,
  },
  {
    name: 'crmId',
    label: 'CRM ID',
    matching: FilterMatchingType.STRING_INCLUDES,
    value: '',
  },
];
